import { VerifiedBadge } from 'src/assets/svgExports/VerifiedBadge';
import RatingBox from 'src/components/RatingBox';
import { REVIEW_MEDIA_TYPE } from '../constants';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import classNames from 'node_modules/classnames/index';

export function VerifiedBuyerBadge({ className = '' }) {
  return (
    <span
      className={`tw-flex tw-items-center tw-gap-[2px] tw-text-[14px]/[18px] tw-font-semibold tw-italic tw-text-[#2B74D8] ${className}`}
    >
      <VerifiedBadge /> Verified Buyer
    </span>
  );
}

export function ReviewerInfo({ review }) {
  const contact = review?.full_name || review?.phone || review?.email;

  return (
    <div className="tw-flex tw-flex-col tw-gap-[12px]">
      <div className="tw-flex tw-gap-[12px]">
        <RatingBox
          isVisible={!!review?.rating}
          rating={review?.rating}
          isNewStyledRatingBox={false}
        />
        {!!review?.verified_buyer && <VerifiedBuyerBadge />}
      </div>
      <p className="tw-m-0 tw-text-[12px]/[18px] tw-font-normal tw-text-[#00000094]">
        Reviewed on{' '}
        {new Date(review?.review_date).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        })}{' '}
        {!!contact && `by ${contact}`}
      </p>
    </div>
  );
}

export function ReviewMediaRendered({ media, onClick, size = 110 }) {
  return (
    <div
      className={classNames(
        'border-grey1 tw-relative tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[4px] tw-object-contain',
        onClick ? 'tw-cursor-pointer' : ''
      )}
      onClick={onClick}
      style={{
        width: size,
        height: size,
      }}
    >
      <img
        src={media?.thumbnail_url || media?.media_url}
        className="!tw-h-auto tw-max-h-full !tw-w-auto tw-max-w-full"
      />
      {media?.media_type === REVIEW_MEDIA_TYPE.VIDEO && (
        <div className="tw-absolute tw-inset-0 tw-bg-[#00000059]">
          <span className="tw-absolute tw-left-[50%] tw-top-[50%] tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white">
            <PlayCircleOutlineRoundedIcon />
          </span>
        </div>
      )}
    </div>
  );
}
